export default __webpack_public_path__ + "static/media/Resume.d63df0c9.pdf";